function dildoAnim(conf){
    conf=$.extend({
        girl_a:1,
        girl_b:1,
        dildo_id:1
    },conf);
    this.conf=conf;
    this.girl_names=[$.takeGirlImage(conf.girl_a),$.takeGirlImage(conf.girl_b)];
}
dildoAnim.prototype={
    preparePreloader:function(){
        var girl_conf=this.privPrepareGirlConf();
        
        var loader={
            "dildo":_IMG_SERV+"/gfx/place/dildogame/girls/dildo/"+this.conf.dildo_id+"/skeleton.json"
        };
        var i,conf,key,keyBig,k;
        var qname=["a","b"];
        for(i=0;i<2;i++){
            conf=girl_conf[this.girl_names[i]];
            key=qname[i];
            keyBig=key.toUpperCase();
            for(k=1;k<=conf[key];k++){
                loader[k+key]=_IMG_SERV+"/gfx/place/dildogame/girls/"+this.girl_names[i]+"/"+keyBig+k+"/skeleton.json";
            }
        }
        return loader;
    },
    addAnimToContainer:function(container,resources){
        var arrConf=this.privPrepareQueue();
        var arrObj={};
            
        var i,bum,type;

        for(i in arrConf){
            type=arrConf[i];
            arrObj[type]=new myPixiElement.spine({
                img:type,
                spine_conf:{
                    freeze_part:0,
                    updateAnim:true,
                    anim_loop:true,
                    spineResource:resources
                }
            });
            
            
            
//            arrObj[type]=new PIXI.spine.Spine(resources[type].spineData);
//
//            arrObj[type].autoUpdate = false;
//            arrObj[type].state.setAnimation(0,"animation",true);
//            arrObj[type].update(0);

            container.addChild(arrObj[type]);
        }
        return arrObj;
    },
    privPrepareGirlConf:function(){
        var girlConfAll={
            custom:{a:2,b:2},
            cupid:{a:3,b:2},
        };
        var ready={};
        ready[this.girl_names[0]]=copyObj(girlConfAll.custom);
        ready[this.girl_names[1]]=copyObj(girlConfAll.custom);
        var i;
        for(i=0;i<2;i++){
            if(typeof girlConfAll[this.girl_names[i]] !="undefined"){
                ready[this.girl_names[i]]=$.extend(ready[this.girl_names[i]],girlConfAll[this.girl_names[i]]);
            }
        }
        return ready;
    },
    privPrepareQueue:function(){
        var girl_conf=this.privPrepareGirlConf();
        
        var ready=[],ret=[];
        var i,conf,key,key_org,keyBig,k;
        var qname=["a","b"];
        for(i=0;i<2;i++){
            conf=girl_conf[this.girl_names[i]];
            key=qname[i];
            for(k=1;k<=conf[key];k++){
                ready.push(k+key);
            }
        }
        ready.sort().reverse();
        var num;
        for(i in ready){
            key_org=ready[i];
            key=key_org;
            num=intval(key);
            if(key_org.indexOf("a")!=-1 && in_array(num+"b",ready)){
                key=key.replace("a","b");
            }


            if(key_org.indexOf("b")!=-1 && in_array(num+"a",ready)){
                key=key.replace("b","a");
            }
            ret.push(key);
            if(key=="2b"){
                ret.push("dildo");
            }
        }
        return ret;
    }
};